import Success from './Success';
export type { SuccessProps } from './Success.types';

export default Success;
